
import { Options, Vue } from 'vue-class-component';
import YearResults from '@/components/YearResults.vue';
import SelectMenu from '@/components/SelectMenu.vue';

@Options({
  components: {
    SelectMenu,
    YearResults,
  },
})
export default class Year extends Vue {
  years: { name: string, id: string }[] = [];

  created() {
    this.loadResults();
  }

  get year(): string {
    return Array.isArray(this.$route.params.year) ? this.$route.params.year[0] : this.$route.params.year;
  }

  get listYear(): { name: string, id: string} {
    return this.years.find((y) => y.name === this.year) ?? { name: '', id: '' };
  }

  set listYear(val: { name: string, id: string }) {
    console.log('here');
    this.$router.push({ name: 'Year', params: { year: val.name } });
  }

  // eslint-disable-next-line class-methods-use-this
  loadResults(): void {
    console.log('Loading results...');
    this.axios.get(`${process.env.VUE_APP_APIURL}/totals`)
      .then((res) => {
        // Map API results to the select items and sort so the latest year is first.
        const years = res.data
          .map((r: { name: string }) => ({ name: r.name, id: r.name }))
          .sort((a: { name: string, id: string }, b: { name: string, id: string }) => {
            const na = parseInt(a.name, 10);
            const nb = parseInt(b.name, 10);
            if (!Number.isNaN(na) && !Number.isNaN(nb)) {
              // Numeric descending (latest year first)
              return nb - na;
            }
            // Fallback to string descending
            return b.name.localeCompare(a.name);
          });
        console.log(years);
        this.years = years;
      });
  }
}
